import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {globals} from '@extensions/globals-base'
import {MenuIconButtonWithDropdown} from '../components/menu-icon-button-with-dropdown'
import {myCompanyPage, profilePage} from '../constants'
import {changeCompany, goto} from '../handlers/main-handlers'
import {MainMenuCompany, useMainMenuStore} from '../main-menu-store'

const hasUnseenMsg = (companies: MainMenuCompany[]) => {
  return companies.some(c => c.newMsg > 0)
}

export const CompanyListMenuItem = observer(() => {
  const [state] = useMainMenuStore()

  const {companies} = state

  const currentCompanyId = globals.getCompanyId()

  const options: OptionsItem[] = companies.map(company => {
    const {id, name: text, newMsg} = company
    return {
      key: id,
      text,
      selected: currentCompanyId === id,
      cb: () => {
        changeCompany(id)
        void Tracking.send(TrackingEvent.leftPanelChangeCompanyClick)
      },
      count: newMsg ? String(newMsg) : undefined,
      highlightNumber: true
    }
  })

  options.unshift({
    key: 'companiesSettings',
    text: Lang.msg.menu.companiesSettings,
    cb: () => {
      goto(profilePage)
      void Tracking.send(TrackingEvent.leftPanelCompaniesSettingsClick)
    }
  })

  const gotoProjects = () => goto(myCompanyPage)
  const notify = hasUnseenMsg(companies)

  return (
    <MenuIconButtonWithDropdown
      options={options}
      icon="IconBuilding"
      onClick={gotoProjects}
      notification={notify}
      className="mt-auto"
    />
  )
})
